import React, {useState} from 'react';
import { connect } from 'react-redux';
import {FormattedMessage} from "react-intl";
import Switcher from "../../../ui/Switcher";
import PropTypes from "prop-types";
import sqftShape from "../../../canvas/core/shapes/sqftShape";

const SectionCustomBox = (props) => {
  const {shape} = props
  const [isAddBoxEnabled, setIsAddBoxEnabled] = useState(shape.shouldAddCabinetBox);
  const onChange = () => {
    setIsAddBoxEnabled(!isAddBoxEnabled);
    shape.setShouldAddCabinetBox(!isAddBoxEnabled);
    //shape.setIsDisabledInPopup(isAddBoxEnabled);
    console.log("shape shouldAddCabinetBox", shape.shouldAddCabinetBox);
  }

  return (
    <div className="sr__section sr__handles">
      <div className="sr__section-title">
        <FormattedMessage id="Cabinet Box Addition"/>
      </div>
      <div className="sr__section-sides">
        <FormattedMessage id="Add as custom box"/>
        <span>
          <Switcher value={isAddBoxEnabled} onChange={onChange} />
        </span>
      </div>
    </div>
  );
};

SectionCustomBox.propTypes = {
  shape: PropTypes.instanceOf(sqftShape)
}

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionCustomBox);
